<template>
  <Deliveries />
</template>

<script lang="ts">
import Vue from 'vue';
import Deliveries from '../components/Deliveries.vue';

export default Vue.extend({
    components: {
        Deliveries,
    },
});
</script>
